import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import { failed, success } from "../../../Utils/Alerts";
import { getCookie, setCookie } from "../../../Utils/Cookies";
import { _serverUrl2 } from "../../../config";
import { loadingSc } from "../../Layout/AlertDiv";
import { tempLayer, zoomToFeatureByXY } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";
import "./HouseSignDashboard.css";
import { Confirm } from "notiflix";

export default function HouseSignDashboard() {
  const history = useHistory();

  const { islem_durum, kontrol_durum, ilce, mahalle, csbm, page, pageSize } = JSON.parse(getCookie("_search_json") || "{}");

  const [info, setInfo] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [mahalleler, setMahalleler] = useState([]);
  const [csbmler, setCsbmler] = useState([]);
  const [selectedProje, setSelectedProje] = useState("");
  const [islemDurum, setIslemDurum] = useState(islem_durum || "");
  const [kontrolDurum, setKontrolDurum] = useState(kontrol_durum || "");
  const [selectedIlce, setSelectedIlce] = useState(ilce || "");
  const [selectedMahalle, setSelectedMahalle] = useState(mahalle || "");
  const [selectedCsbm, setSelectedCsbm] = useState(csbm || "");
  const [currentPage, setCurrentPage] = useState(page || 0);
  const [selectedPageSize, setSelectedPageSize] = useState(pageSize || 10);
  const [totalPages, setTotalPages] = useState(0);

  const fetchData = async (url, setData) => {
    try {
      const res = await axios.get(url);
      if (res.data.status) {
        setData(res.data.rows);
      } else {
        failed("Bilgiler alınırken hata oluştu " + res.data.error);
      }
    } catch (error) {
      failed("Bilgiler alınırken hata oluştu " + error);
    } finally {
      loadingSc(false);
    }
  };

  const onClickDeleteLevha = (id) => {
    Confirm.show("Emin misiniz", "Levhayı Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", async () => {
      await axios.post(_serverUrl2 + "/sign/delete/levha", { id: id }).then(() => {
        success("Levha Silindi!");
        getInfosFromNode();
      });
    });
  };

  const onChangeIlce = async (e) => {
    setSelectedIlce(e.target.value);
    if (e.target.value) {
      await fetchData(`${_serverUrl2}/main/mah/${e.target.value}`, setMahalleler);
    }
  };

  const onChangeMahalle = async (e) => {
    setSelectedMahalle(e.target.value);
    if (e.target.value) {
      await fetchData(`${_serverUrl2}/main/csbm/${e.target.value}`, setCsbmler);
    }
  };

  const getInfosFromNode = async () => {
    loadingSc(true);
    await fetchData(`${_serverUrl2}/main/ilce`, setIlceler);
    const searchJson = getCookie("_search_json");
    if (searchJson) {
      await onSubmitSearch(JSON.parse(searchJson));
      return;
    }
    await fetchData(`${_serverUrl2}/hsign/getLastByLimit/50`, setInfo);
  };

  const onSubmitSearch = async (pastJson = null, newPage = currentPage) => {
    // react-paginate sayfa indeksleri 0'dan başlar
    loadingSc(true);
    const json = pastJson
      ? { ...pastJson, page: newPage }
      : {
          ilce: selectedIlce,
          mahalle: selectedMahalle,
          csbm: selectedCsbm,
          islem_durum: islemDurum,
          kontrol_durum: kontrolDurum,
          page: newPage,
          pageSize: selectedPageSize,
        };

    setCookie("_search_json", JSON.stringify(json), 4);

    try {
      const res = await axios.post(`${_serverUrl2}/hsign/getByFilter`, json);
      if (res.data.status) {
        setInfo(res.data.rows);
        const totalCount = res.data.totalCount;
        setTotalPages(Math.ceil(totalCount / selectedPageSize));
        setCurrentPage(newPage); // Arama sonrası sayfa numarasını güncelle
      } else {
        failed("Hata Oluştu");
      }
    } catch (error) {
      failed("Hata Oluştu");
    } finally {
      loadingSc(false);
    }
  };

  const belgeOlustur = () => {
    const json = {
      ilce: selectedIlce,
      mahalle: selectedMahalle,
      csbm: selectedCsbm,
      islem_durum: islemDurum,
      kontrol_durum: kontrolDurum,
    };

    axios({
      url: `${_serverUrl2}/hsign/excel`,
      method: "POST",
      data: json,
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "TabloExcel.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  };

  useEffect(() => {
    getInfosFromNode();
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    }; // eslint-disable-next-line
  }, []);

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    onSubmitSearch(JSON.parse(getCookie("_search_json")), selectedPage);
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-center">
            <b>Levha-Numarataj</b>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-6">
            <select value={islemDurum} onChange={(e) => setIslemDurum(e.target.value)} className="form-control form-select">
              <option value={""} disabled>
                İşlem Durumu
              </option>
              <option value={""}>HEPSİ</option>
              <option>YAPILMADI</option>
              <option>TAKILDI</option>
              <option>TAKILAMADI</option>
              <option>HATALI_TAKILDI</option>
            </select>
          </div>
          <div className="col-sm-6">
            <select value={kontrolDurum} onChange={(e) => setKontrolDurum(e.target.value)} className="form-control form-select">
              <option value={""} disabled>
                Kontrol Durumu
              </option>
              <option value={""}>HEPSİ</option>
              <option>UYGUN</option>
              <option>HATALI</option>
              <option>BEKLEMEDE</option>
            </select>
          </div>
          <div className="col-sm-4">
            <select value={selectedIlce} onChange={onChangeIlce} className="form-control form-select">
              <option value={""}>Tüm İlçe</option>
              {ilceler.map((d, i) => (
                <option key={i} value={d.maks_kimlik_no}>
                  {d.ad}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-4">
            <select value={selectedMahalle} onChange={onChangeMahalle} className="form-control form-select">
              <option value={""}>Tüm Mah</option>
              {mahalleler.map((d, i) => (
                <option key={i} value={d.mah_id}>
                  {d.mah_adi}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-4 tum-csbm">
            <select value={selectedCsbm} onChange={(e) => setSelectedCsbm(e.target.value)} className="form-control form-select">
              <option value={""}>Tüm CSBM</option>
              {csbmler.map((d, i) => (
                <option key={i} value={d.maks_kimlik_no}>{`${d.yol_ismi} ${d.yol_tipi}`}</option>
              ))}
            </select>
          </div>

          <div className="col-sm-4">
            <select value={selectedPageSize} onChange={(e) => setSelectedPageSize(e.target.value)} className="form-control form-select">
              <option value={10}>Sayfa Başına 10</option>
              <option value={50}>Sayfa Başına 50</option>
              <option value={100}>Sayfa Başına 100</option>
            </select>
          </div>
          <div className="col-sm-4">
            <button className="darkOrangeBtn col-sm-1" onClick={belgeOlustur}>
              Excel
            </button>
          </div>
          <div className="col-sm-4">
            <button className="greenBtn arama" onClick={() => onSubmitSearch()}>
              Arama Yap
            </button>
          </div>
          <div className="col-sm-12">&nbsp;</div>
        </div>

        <div className="col-sm-12">
          <div className="textBox">
            <div className="content">
              {totalPages != 0 && (
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  pageCount={totalPages}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination pagination-sm d-flex justify-content-center my-1"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  forcePage={currentPage} // Arama sonrası sayfa numarasını sıfırla
                />
              )}
              <table className="table table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th className="th-konum">Konum</th>
                    <th colSpan={1}>İşlem Durum</th>
                    <th colSpan={3}>İlçe</th>
                    <th colSpan={3}>Mahalle</th>
                    <th colSpan={3}>CSBM</th>
                    <th colSpan={1}>Kapı No</th>
                    <th className="th-ayrinti">Ayrıntı</th>
                  </tr>
                </thead>
                <tbody>
                  {info.map((datum) => (
                    <Fragment key={datum.id}>
                      <tr
                        valign="middle"
                        onClick={() => setSelectedProje(selectedProje === datum.id ? null : datum.id)}
                        className={`tr-kontrol-durum ${
                          datum.kontrol_durum === "UYGUN" ? "tr-kontrol-durum-uygun" : datum.kontrol_durum === "HATALI" ? "tr-kontrol-durum-hatali" : ""
                        }`}
                      >
                        <td className="td-konum" onClick={() => zoomToFeatureByXY(datum.x, datum.y)}>
                          <Icon path={mdiMapMarker} size={1.5} className="icon" />
                        </td>
                        <td colSpan={1} className="td">
                          {datum.islem_durum}
                        </td>
                        <th colSpan={3}>{datum.ilce}</th>
                        <th colSpan={3}>{datum.mah}</th>
                        <th colSpan={3}>{datum.csbm}</th>
                        <th colSpan={1} className="td">
                          {datum.kapi_no}
                        </th>
                        <td className="td-ayrinti">
                          <center>
                            <button className="greenBtn ayrintiBtn" onClick={() => history.push(`/dashboard/hsign/update/${datum.id}`)}>
                              <i className="fas fa-folder-open"></i>
                            </button>
                            &nbsp;
                            {selectedProje === datum.id ? (
                              <button onClick={() => setSelectedProje(null)} className="greenBtn akordiyonBtn">
                                <i className="fas fa-angle-double-up"></i>
                              </button>
                            ) : (
                              <button onClick={() => setSelectedProje(datum.id)} className="whiteBtn akordiyonBtn">
                                <i className="fas fa-angle-double-down"></i>
                              </button>
                            )}
                            <button className="redBtn" style={{ display: datum.islem_durum == "TAKILDI" ? "NONE" : "block" }} onClick={() => onClickDeleteLevha(datum.id)}>SİL</button>
                          </center>
                        </td>
                      </tr>
                      {selectedProje === datum.id && (
                        <>
                          <tr className="tr-ayrinti">
                            <th className="th-ayrinti" colSpan={2}>
                              Kontrol Durum
                            </th>
                            <td colSpan={4}>{datum.kontrol_durum}</td>
                            <th>Kontrol Açıklaması</th>
                            <td colSpan={6}>{datum.kontrol_aciklama}</td>
                          </tr>
                          <tr className="tr-ayrinti">
                            <th className="th-ayrinti" colSpan={2}>
                              Son Güncelleyen Kullanıcı
                            </th>
                            <td colSpan={4} className="td-ayrinti">
                              {datum.son_guncelleyen_kullanici}
                            </td>
                            <th>Saha Açıklaması</th>
                            <td colSpan={6}>{datum.aciklama}</td>
                          </tr>
                          <tr className="tr-ayrinti">
                            <th className="th-ayrinti" colSpan={2}>
                              Maks Num Kn
                            </th>
                            <td colSpan={4} className="td-ayrinti">
                              {datum.maks_num_kn}
                            </td>
                            <th>Son Güncellenme</th>
                            <td colSpan={6} className="td-ayrinti">
                              {datum.son_guncellenme_tarihi?.split("T")[0]}
                            </td>
                          </tr>
                        </>
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
